// ============================================================
// Dataset do template "dashboard" (Painel de Plano de Negocios)
// ============================================================
// Dados puros (serializaveis) consumidos por Dashboard.tsx e usados
// como defaultData em dashboard.ts. Git-data-driven: editar o dataset
// = commit. page.data pode sobrescrever os ESCALARES (tagline/precos/
// defaults do simulador) via admin; arrays ricos vivem aqui no git.
//
// BLINDAGEM STRIPE: nada de "visto/imigracao/juridico/assessoria" em
// texto destinado a publicacao. Os campos `focus` (aba investidor) e
// `pain` (dor) sao insumo INTERNO de targeting; a copy "para veicular"
// e gerada blind no componente (envelope: Protocolo de Aceleracao /
// A Brecha dos 2 Anos). Sem travessao (—).
// ============================================================

export interface DashCountry {
  id: string
  name: string
  flag: string
  stock: number
  newYear: number
  /** insumo interno de posicionamento (nao publicar cru) */
  focus: string
  /** dor (permitido em copy) */
  pain: string
  /** gatilho de copy p/ atrair pra Espanha — ANGULO INTERNO (nomeia mecanismo; enveloplar antes de veicular) */
  gatilho: string
}

export const DASH_COUNTRIES: DashCountry[] = [
  { id: 'us', name: 'Estados Unidos', flag: '🇺🇸', stock: 26_500_000, newYear: 630_000,
    focus: 'Poder do dolar somado ao esgotamento corporativo.',
    pain: 'trocar um salario de seis digitos por semanas de sessenta horas em uma cidade que nunca desacelera',
    gatilho: 'Viver com qualidade europeia gastando em dolar; obter o passaporte da UE em 2 anos.' },
  { id: 'es', name: 'Espanha', flag: '🇪🇸', stock: 2_800_000, newYear: 140_000,
    focus: 'Converter a estadia provisoria em residencia estavel de longo prazo.',
    pain: 'viver no limite, em status provisorio, sem um caminho estruturado para a estabilidade',
    gatilho: 'Regularizacao imediata; transicao de visto de turista para Nomade Digital; otimizacao fiscal (Lei Beckham).' },
  { id: 'pt', name: 'Portugal', flag: '🇵🇹', stock: 600_000, newYear: 65_000,
    focus: 'Escapar dos salarios baixos e da lentidao da AIMA.',
    pain: 'salarios baixos e atendimentos da AIMA que somem antes de voce conseguir agendar',
    gatilho: 'Fugir do caos burocratico da AIMA; trocar os salarios baixos de Portugal pela estrutura espanhola sem zerar o cronometro da cidadania.' },
  { id: 'ca', name: 'Canada', flag: '🇨🇦', stock: 500_000, newYear: 35_000,
    focus: 'Fugir do inverno de menos 20C e do isolamento profundo.',
    pain: 'a escuridao de menos 20C, o isolamento e um custo de vida que so aumenta',
    gatilho: 'Trocar o inverno congelante de -20C e o isolamento cultural pelo sol, custo de vida atraente e lifestyle da Espanha.' },
  { id: 'it', name: 'Italia', flag: '🇮🇹', stock: 450_000, newYear: 25_000,
    focus: 'Sair de uma economia estagnada rumo a um polo de tecnologia.',
    pain: 'uma economia estagnada, sem espaco para uma carreira remota ambiciosa',
    gatilho: 'Escapar do mercado de trabalho estagnado e da lentidao da burocracia italiana para se estabelecer no hub tech espanhol.' },
  { id: 'uk', name: 'Reino Unido', flag: '🇬🇧', stock: 347_000, newYear: 22_000,
    focus: 'Isolamento pos-Brexit e alugueis brutais em Londres.',
    pain: 'o isolamento pos-Brexit e os alugueis de Londres consumindo metade do seu salario',
    gatilho: 'Efeito pos-Brexit: recuperar o direito de livre circulacao pela Uniao Europeia e fugir dos alugueis sufocantes de Londres.' },
  { id: 'ie', name: 'Irlanda', flag: '🇮🇪', stock: 120_000, newYear: 15_000,
    focus: 'A grave crise habitacional de Dublin e o ceu sempre cinza.',
    pain: 'a crise habitacional de Dublin e o ceu cinza nove meses por ano',
    gatilho: 'Crise de habitacao de Dublin: espaco, sol e seguranca para a familia em vez de fortunas por espacos minusculos. (derivado; nao estava na tabela original)' },
]

export interface DashLifeStage {
  id: string
  label: string
  iconKey: string
  hook: string
  angle: string
  drive: string
}

export const DASH_LIFE_STAGES: DashLifeStage[] = [
  { id: 'single', label: 'Jovem Solteiro', iconKey: 'Sparkles',
    hook: 'Acelere sua carreira nos polos de tecnologia da Europa.',
    angle: 'Carreira acelerada + vida social', drive: 'crescimento rapido de carreira, networking nos polos de tecnologia da Europa e uma vida social que realmente existe' },
  { id: 'married', label: 'Jovem Casado (Sem Filhos)', iconKey: 'Plane',
    hook: 'Construa uma carreira dupla remota e conheca a Europa todo fim de semana.',
    angle: 'Renda dupla + liberdade', drive: 'duas rendas remotas se multiplicando enquanto voces conhecem o continente nos fins de semana' },
  { id: 'family', label: 'Familia com Filhos', iconKey: 'ShieldCheck',
    hook: 'Seguranca, educacao publica premium e espaco para criar a familia.',
    angle: 'Seguranca + educacao', drive: 'seguranca, escolas publicas premium e espaco de verdade em vez de um apartamento apertado' },
  { id: 'divorced', label: 'Recem-Divorciado', iconKey: 'Heart',
    hook: 'Aperte o reset: autonomia financeira e uma vida social nova em folha.',
    angle: 'O recomeco total', drive: 'um recomeco limpo, com autonomia financeira e um novo circulo social em uma cultura acolhedora' },
  { id: 'grief', label: 'Em Luto', iconKey: 'GraduationCap',
    hook: 'Um ambiente de cura e um ritmo mais calmo para reconstruir.',
    angle: 'Cura + transicao', drive: 'um ambiente de cura, um ritmo mais lento e uma transicao patrimonial transfronteirica tranquila' },
  { id: 'retired', label: 'Aposentado', iconKey: 'Crown',
    hook: 'Preserve seu patrimonio com o protocolo de residencia patrimonial.',
    angle: 'Patrimonio + saude', drive: 'preservacao de patrimonio, saude de classe mundial e o estilo de vida que voce conquistou' },
]

export interface DashStatus {
  id: string
  label: string
  short: string
  iconKey: string
  summary: string
  coreHook: string
}

export const DASH_STATUSES: DashStatus[] = [
  { id: 'native', label: 'Na Terra Natal', short: 'Terra Natal', iconKey: 'Flag',
    summary: 'Alta intencao, preparando-se para sair. Sensivel ao preco, mas volume enorme.',
    coreHook: 'Planejamento seguro de internacionalizacao.' },
  { id: 'emigrant', label: 'Ja sao Emigrantes', short: 'Emigrante', iconKey: 'Globe2',
    summary: 'Alta dor local, necessidade urgente de otimizacao geografica e fiscal.',
    coreHook: 'Escape da crise local atual e estabeleca-se na Europa.' },
]

export interface DashPhase {
  id: string
  n: string
  name: string
  window: string
  progress: number
  focus: string
  tasks: string[]
  squad: string[]
  market: string
}

export const DASH_PHASES: DashPhase[] = [
  { id: 'p1', n: '01', name: 'Validacao', window: 'M01 - M03', progress: 100,
    focus: 'Atingir o Publico 2 (Emigrantes) no Reino Unido, Portugal e Irlanda com anuncios de dor diretos.',
    tasks: ['Lancar anuncios focados na dor (alugueis de Londres, moradia em Dublin, atrasos da AIMA)',
            'Validar a conversao do front-end de 9,90', 'Provar o fit mensagem-mercado por pais'],
    squad: ['Growth', 'Copy', 'Commercial'],
    market: 'Publico 2 (Emigrantes) · Reino Unido · Portugal · Irlanda' },
  { id: 'p2', n: '02', name: 'Escala & Automacao com IA', window: 'M04 - M06', progress: 55,
    focus: 'Expandir para o publico de lingua espanhola com automacao por clonagem de voz com IA.',
    tasks: ['Implantar clonagem de voz com IA para criativos localizados', 'Lancar fluxos automatizados no Manychat',
            'Localizar funis nos mercados de espanhol da America Latina'],
    squad: ['Tech', 'Video Maker', 'Growth'],
    market: 'Lingua espanhola na America Latina · funis localizados com IA' },
  { id: 'p3', n: '03', name: 'Consolidacao', window: 'M07+', progress: 15,
    focus: 'Converter membros do front-end em receita de back-end de ticket alto no ecossistema.',
    tasks: ['Escalar a conversao de front-end para back-end de ticket alto', 'Otimizar a retencao do MRR de 30',
            'Travar a economia unitaria e o caixa'],
    squad: ['CFO', 'Strategy', 'Full Squad'],
    market: 'Base completa · front-end para back-end de ticket alto' },
]

export interface DashDefaults {
  brandTagline: string
  netInflow: number
  fePrice: number
  mrrPrice: number
  captureDefault: number
  mrrConvDefault: number
  tamNow: string
  tam5y: string
  tam5yDelta: string
  netInflowLabel: string
}

export const DASH_DEFAULTS: DashDefaults = {
  brandTagline: 'Protocolo de Aceleracao Ibero-Americano · A Brecha dos 2 Anos · Plano de Negocios',
  netInflow: 1_152_000,
  fePrice: 9.9,
  mrrPrice: 30,
  captureDefault: 0.5,
  mrrConvDefault: 20,
  tamNow: '47,94M',
  tam5y: '54,70M',
  tam5yDelta: '+6,76M de estoque projetado',
  netInflowLabel: '1,15M',
}
